var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "uikit-page" }, [
    _c(
      "div",
      [
        _c("table-columns-modal", {
          ref: "tableColumnsModal",
          attrs: {
            columns: _vm.columns,
            "default-selected": _vm.defaultSelectedColumns,
          },
          on: {
            apply: function ($event) {
              _vm.selectedColumns = $event
            },
          },
        }),
        _c("c-button", {
          attrs: { responsive: "", icon: "cog", label: "Настроить столбцы" },
          on: { click: _vm.configureColumns },
        }),
      ],
      1
    ),
    _c("div", { staticClass: "layout__hr" }),
    _c(
      "div",
      [
        _c("comment-modal", { ref: "commentModal" }),
        _c("link-modal", {
          ref: "linkModal",
          attrs: { title: "Ссылка на Google Таблицы" },
        }),
        _c(
          "div",
          { staticClass: "d-flex" },
          [
            _c("c-button-2", {
              directives: [
                {
                  name: "b-popover",
                  rawName: "v-b-popover.html",
                  value: {
                    container: "#app",
                    trigger: "hover blur",
                    content: "Комментарий",
                    placement: "top",
                  },
                  expression:
                    "{\n          container: '#app',\n          trigger: 'hover blur',\n          content: 'Комментарий',\n          placement: 'top',\n        }",
                  modifiers: { html: true },
                },
              ],
              staticClass: "mr-4",
              attrs: { size: "iconic", icon: "comment" },
              on: {
                click: function ($event) {
                  return _vm.showComment()
                },
              },
            }),
            _c("c-button", {
              attrs: {
                icon: {
                  icon: "google",
                  color: "green",
                },
                label: "Выгрузить в Google таблицы",
                responsive: "",
              },
              on: { click: _vm.copyLink },
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c("div", { staticClass: "layout__hr" }),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-6" },
        [
          _c("h3", { staticClass: "layout__subtitle" }, [
            _vm._v("Фильтры для разных типов данных"),
          ]),
          _c("column-filter-modal", {
            ref: "columnFilterModal",
            on: { apply: _vm.applyColumnFilter },
          }),
          _c("table", { staticClass: "h-table" }, [
            _c("thead", [
              _c(
                "tr",
                _vm._l(_vm.filters, function (filter) {
                  return _c("td", { key: filter.type }, [
                    _vm._v(" " + _vm._s(filter.type) + " "),
                  ])
                }),
                0
              ),
            ]),
            _c("tbody", [
              _c(
                "tr",
                _vm._l(_vm.filters, function (filter) {
                  return _c(
                    "td",
                    { key: filter.type },
                    [
                      _c("c-button", {
                        attrs: {
                          icon: {
                            icon: "filter-column",
                            activeColor: "blue",
                          },
                          tooltip: {
                            text: "Применить фильтр",
                            activeText: "Изменить фильтр",
                          },
                          "no-border": "",
                          size: "small",
                          active: filter.value,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.configureColumnFilter(filter)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
                0
              ),
            ]),
          ]),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }